import {
    useInnerBlocksProps,
     useBlockProps,
} from '@wordpress/block-editor';
import noimagelong from "../../../../../inc/assets/img/no-image-long.png";
import { useEffect } from '@wordpress/element';
import { useSelect, useDispatch } from '@wordpress/data';
import { store as blockEditorStore } from '@wordpress/block-editor';

const ALLOWED_BLOCKS = [
    'vayu-blocks/image',
    'vayu-blocks/video',
    'core/image',
    'core/gallery',
    'core/video',
    'vayu-blocks/advance-container',
];

const DEFAULT_BLOCK = 'vayu-blocks/advance-container';
const DEFAULT_BLOCK_ATTRIBUTES = {
    image: noimagelong,
    overlayshow: false,
    overlaycolor: '#abb8c3',
    contentani: false,
};
  
const DEFAULT_CHILD_TEMPLATE = [
    [
        DEFAULT_BLOCK,
        { className: 'swiper-slide', 
            advPadding: {
                Desktop: '0px',
                Tablet: '0px',
                Mobile: '0px'
            } 
        },
        [
            [ 'vayu-blocks/image', { ...DEFAULT_BLOCK_ATTRIBUTES } ]
        ]
    ],
    [
        DEFAULT_BLOCK,
        { className: 'swiper-slide',
            advPadding: {
                Desktop: '0px',
                Tablet: '0px',
                Mobile: '0px'
            } 
         },
        [
            [ 'vayu-blocks/image', { ...DEFAULT_BLOCK_ATTRIBUTES } ]
        ]
    ]
];

export default  function ChildeBlock({clientId}){

    const innerBlocksProps = useInnerBlocksProps(
        { className: 'swiper-wrapper vayu_blocks_advance_slider' },
        {
            allowedBlocks: ALLOWED_BLOCKS,
            directInsert: true,
            orientation: 'horizontal',
            template: DEFAULT_CHILD_TEMPLATE,
            renderAppender: false,
        }
    );

   const { getBlocks } = useSelect(select => select(blockEditorStore), []);
    const { updateBlockAttributes } = useDispatch(blockEditorStore);

    // 👇 Get child blocks on every render
    const childBlocks = useSelect(
        (select) => select(blockEditorStore).getBlocks(clientId),
        [clientId]
    );

    useEffect(() => {
        childBlocks.forEach((child) => {
            const className = child.attributes.className || '';
            if (!className.includes('swiper-slide')) {
                updateBlockAttributes(child.clientId, {
                    className: (className + ' swiper-slide').trim(),
                });
            }
        });
    }, [childBlocks]);

    return <div {...innerBlocksProps} />
}